const DECIMAL_PRECISION = 1;

export const roundOffNumber = num => {
  if (num) return Number(num.toFixed(DECIMAL_PRECISION));
  return 0;
};
